import { render } from "./SchedaPratica.vue?vue&type=template&id=06ed0e23"
import script from "./SchedaPratica.vue?vue&type=script&lang=js"
export * from "./SchedaPratica.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francescoscialacqua/Sviluppo/emmet.client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__